import { Component, OnDestroy } from '@angular/core';
import { DeploymentService } from '../store/deployment.service';
import { Subscription } from 'rxjs';
import { DeploymentLevel, LssDeploymentEntity, LssEntityStatus } from '../store/deployment.datamodel';
import { AppService } from '../../application/app.service';
import { ORG_OGU_COMPONENTS_TYPES } from '../../publish/component/store/component.datamodel';
import { IsDeploymentDisabledPipe } from '../pipes/is-deployment-disabled.pipe';
import { IsEntityDeployedPipe } from '../pipes/is-entity-deployed.pipe';

@Component({
    selector: 'ama-ng-app-store-deployment-offices-list',
    templateUrl: './deployment-offices-list.component.html',
    styleUrls: ['./deployment-offices-list.component.scss'],
    standalone: false
})
export class DeploymentOfficesListComponent implements OnDestroy {
  subscription: Subscription = new Subscription();
  offices: LssDeploymentEntity[] = [];
  allDisabled = false;
  selectAllChecked = false;
  canDeployOrgOgu = false;
  protected readonly DeploymentLevel = DeploymentLevel;

  constructor(public readonly deploymentService: DeploymentService,
              private readonly appService: AppService,
              private readonly isDeploymentDisabledPipe: IsDeploymentDisabledPipe,
              private readonly isEntityDeployedPipe: IsEntityDeployedPipe) {
    this.subscription.add(deploymentService.officesInSelectedEntity$.subscribe((offices: LssDeploymentEntity[]) => {
      this.offices = offices;
      this.allDisabled = offices.every(office => this.isDeploymentDisabledPipe.transform(office));
      this.selectAllChecked = offices.length > 0 &&
          offices.every(office => this.isEntityDeployedPipe.transform(office));
    }));
    this.subscription.add(this.appService.detailedApp$.subscribe(app => {
      this.canDeployOrgOgu = ORG_OGU_COMPONENTS_TYPES.includes(
        this.appService.getAppComponentsType(app.components, app.applicationType)
      );
    }));
  }

  /**
   * Select or deselect all offices in the selected entity
   */
  onSelectAllCheckboxChange() {
    this.deploymentService.dispatchSetDeploymentOfAllOfficesInSelectedEntity(this.selectAllChecked);
  }

  /**
   * Select or deselect a specific office deployment
   * @param entity target office
   */
  onSelectOfficeDeploymentCheckboxChange(entity: LssDeploymentEntity) {
    this.deploymentService.dispatchToggleEntityDeploymentState(entity.actor);
  }

  /**
   * Select or deselect a specific office exclusion
   * @param entity target office
   */
  onSelectOfficeExclusionsCheckboxChange(entity: LssDeploymentEntity) {
    this.deploymentService.dispatchToggleEntityExclusionState(entity.actor);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Track by function for ngFor
   * @param _index Item index
   * @param entity LSS entity
   */
  trackByFn(_index: number, entity: LssDeploymentEntity) {
    return entity.actor.actorName;
  }

  protected readonly LssEntityStatus = LssEntityStatus;
}
